module.exports = __webpack_public_path__ + "img/health-product-icon.a6d92198.png";